import React from 'react';
import logo from '../../assets/images/logo2x.png';
import rightLowerBG from '../../assets/images/RightImg.png';
import { useLicensingExperienceOptional } from '../../contexts/LicensingExperienceContext';
import { getPlatformBranding } from '../../utils/licensingPlatformBranding';
import './style.css';

const AuthLayout = ({
  children,
  leftTitle,
  leftDescription,
  rightFooterText = 'Copyright © 2026 IQVIA. All Rights Reserved.',
}) => {
  const { mode } = useLicensingExperienceOptional();
  const branding = getPlatformBranding(mode);
  const title = leftTitle ?? branding.title;
  const description = leftDescription ?? branding.description;

  return (
    <div className="authLayoutRoot">
      {/* Left column - background image and footer (hidden on small screens) */}
      <div className="authLayoutLeft">
        <div className="leftBG">
          <div className="overlay">
            <img src={logo} alt="IQVIA Logo" className="logo" />
            <div className="shapes">
              <div className="bigRectangle">
                <div className="textContainer">
                  <h1 className="title">{title}</h1>
                  <p className="description">{description}</p>
                </div>
              </div>
              <div className="smallRectangle"></div>
            </div>
          </div>
          <div className="footer">
            <img src={logo} alt="IQVIA Logo" className="footerLogo" />
            <ul className="footerLinks">
              <li>
                <a
                  href="https://www.iqvia.com/about-us/terms-of-use"
                  target="_blank"
                  rel="noreferrer"
                >
                  Terms of Use
                </a>
              </li>
              <li>
                <a
                  href="https://www.iqvia.com/about-us/privacy/privacy-policy"
                  target="_blank"
                  rel="noreferrer"
                >
                  Privacy Policy
                </a>
              </li>
              <li>
                <a
                  href="mailto:eService@iqvia.com"
                  target="_blank"
                  rel="noreferrer"
                >
                  Contact Us
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Right column - form content and right footer */}
      <div className="authLayoutRight">
        <div className="rightBG">
          <div className="rightBGContent">{children}</div>
          <img
            src={rightLowerBG}
            alt="Decorative"
            className="bottomRightImage"
          />
          <div className="rightFooter">{rightFooterText}</div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
